import type { DynamicGenerationModelConfig } from 'src/services/constants'
import { useDynamicGenerationModelConfig } from 'src/services/constants'

export type ModelTypeTagColors =
  DynamicGenerationModelConfig['modelTypeTagColors']

export function useGenerationModelColorConfig() {
  const { data } = useDynamicGenerationModelConfig()
  return data?.modelTypeTagColors
}
